const VocaMatchingCard = ({ selectedIndex, word, handleClick, type }) => {
  const isSelected = selectedIndex === word.index;
  const isMatched = word.isMatched;
  return (
    <div
      key={word.text}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "16vw",
        height: "25vh",
        border: "1px solid #EBEBEB",
        boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
        borderRadius: "10px",
        padding: "10px",
        boxSizing: "border-box",
        fontSize: "24px",
        wordWrap: "break-word", // 긴 단어를 줄바꿈
        wordBreak: "break-word", // 긴 단어가 있을 경우 강제 줄바꿈
        overflowWrap: "break-word", // 대체 속성 (현대 브라우저 호환성)
        whiteSpace: "normal", // 줄바꿈 허용
        backgroundColor:
          (isSelected || isMatched) &&
          (type === "analysis" ? "rgba(45, 240, 52, 0.15)" : "#EBEBEB"),
        transition: "background-color 0.5s ease",
        textAlign: "center",
      }}
      onClick={() => {
        if (isMatched) return;
        handleClick(word.index);
      }}
    >
      <div>{word.text}</div>
    </div>
  );
};

export default VocaMatchingCard;
